module.exports = __webpack_public_path__ + "img/Matias.f61163d1.jpg";